import React, { PropsWithChildren } from 'react';
import ILink from '../../../types/ILink';
import Hyperlink from '../../../components/atoms/Hyperlink/Hyperlink';

type StateItemWrapperProps = PropsWithChildren<{
  active: boolean;
  link: ILink;
}>;

export function StateItemWrapper({ children, active, link }: StateItemWrapperProps) {
  return active
    ? (
        <div className="page-state__list-current" aria-current="page">
          {children}
        </div>
      )
    : (
        <Hyperlink to={link.url} className="page-state__list-link">
          {children}
        </Hyperlink>
      );
}
